import React from 'react';

function CardIcon1() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="25"
      fill="none"
      viewBox="0 0 38 25"
    >
      <g clipPath="url(#clip0_2_8223)">
        <path
          fill="#FF8A00"
          d="M35 .6H3c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3v-18c0-1.7-1.4-3-3-3z"
          opacity="0.07"
        ></path>
        <path
          fill="#D64D00"
          d="M35 1.6c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2v-18c0-1.1.9-2 2-2h32z"
        ></path>
        <path
          fill="#FF8A00"
          d="M8.971 10.868l.774 1.876H8.203l.768-1.876zm16.075.078h-2.977v.827h2.929v1.24h-2.923v.921h2.977v.74l2.077-2.246-2.077-2.34-.006.858zm-14.063-2.34h3.995l.887 1.935.822-1.94h10.37l1.078 1.19L29.25 8.6h4.763l-3.519 3.851 3.483 3.828h-4.834l-1.078-1.19-1.125 1.19H10.03l-.494-1.19h-1.13l-.495 1.19H4L7.286 8.6h3.43l.267.006zm8.663 1.078h-2.239l-1.5 3.536-1.625-3.536H12.06v4.81L10 9.684H8.007l-2.382 5.512H7.18l.494-1.19h2.596l.494 1.19h2.72v-3.935l1.751 3.941h1.19l1.74-3.929v3.93h1.458l.024-5.52-.001.001zm9.34 2.768l2.531-2.768h-1.822l-1.601 1.726-1.548-1.726h-5.894v5.518h5.81l1.614-1.738 1.548 1.738h1.875l-2.513-2.75z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2_8223">
          <path
            fill="#fff"
            d="M0 0H38V24H0z"
            transform="translate(0 .6)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CardIcon1;
